import React from 'react';
import IIconSvg from './IIconSvg';
import Svg from '../Svg';

const Share: React.FC<IIconSvg> = ({ fill = 'none', stroke = '#0B1215', bgColor, size, className }) => (
  <Svg fill={fill} bgColor={bgColor} size={size} className={className} viewBox="0 0 16 16" path="">
    <path
      d="M2.66675 8V13.3333C2.66675 13.687 2.80722 14.0261 3.05727 14.2761C3.30732 14.5262 3.64646 14.6667 4.00008 14.6667H12.0001C12.3537 14.6667 12.6928 14.5262 12.9429 14.2761C13.1929 14.0261 13.3334 13.687 13.3334 13.3333V8"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10.6666 4.0026L7.99992 1.33594L5.33325 4.0026" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 1.33594V10.0026" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export default Share;
